import { GroupContainer, Heading, KeyValuePair, Tag } from '@msaf/core-react'
import { SearchViewColumn } from '@msaf/generic-search-common'

export type WellMapPopupProps = {
  title?: string
  popupData: Record<string, string>
  mapDetailCols: Array<SearchViewColumn>
}

export default function WellMapPopup({ title, popupData, mapDetailCols }: WellMapPopupProps) {
  let popupTitle = title

  if (!popupTitle) {
    const titleParts = [popupData.councilWellNo, popupData.wellName].filter((part) => !!part).join(' - ')
    popupTitle = titleParts || 'Unnamed well'
  }

  return (
    <>
      <Heading level={1} className='c-marker-panel__heading'>
        {popupTitle}
      </Heading>
      {Array.isArray(popupData.tags) && (
        <GroupContainer verticalSpacing='x-small'>
          {popupData.tags.map((tag) => (
            <Tag key={tag} label={tag} />
          ))}
        </GroupContainer>
      )}

      {mapDetailCols.map((col: SearchViewColumn) => (
        <KeyValuePair key={col.elementKey} label={col.columnHeading} value={popupData[col.elementKey]} />
      ))}
    </>
  )
}
